import type {
  ApiResponse,
  DeptAndManager,
  DeptEmployeeItem,
  DeptItem,
  DeptTreeItem,
  PageResponse,
  QueryDeptEmployeesSchema,
} from "@/types/apis";
import request from "@/utils/request";

// 获取部门下拉树列表
export const getDeptTreeList = () =>
  request.post<ApiResponse<DeptTreeItem[]>>("/purchase/dept/treeselect", {});

// 获取部门下拉树列表
export const getDeptList = (deptName: string) =>
  request.post<ApiResponse<DeptItem[]>>("/purchase/dept/list", {
    deptName,
  });

// 根据部门编码查询员工数据
export const getDeptEmployees = (data: QueryDeptEmployeesSchema) =>
  request.post<PageResponse<DeptEmployeeItem>>("/purchase/user/page", data);

/**
 * 分页查询系统用户（包含子部门用户）列表
 */
export const getPageSubDeptList = (data: QueryDeptEmployeesSchema) =>
  request.post<PageResponse<DeptEmployeeItem>>(
    "/purchase/user/pageSubDeptList",
    data,
  );

/**
 * 分页查询部门用户列表
 */
export const getPageDeptList = (data: QueryDeptEmployeesSchema) =>
  request.post<PageResponse<DeptEmployeeItem>>(
    "/purchase/user/pageCurrentDeptList",
    data,
  );

/** 根据申请人获取部门及部门主管 */
export const getDeptAndManagerByApplicant = (
  srmPurchaseUserId: string | number,
) =>
  request.get<ApiResponse<DeptAndManager>>(
    `/purchase/user/getPurchaseUserInfoById/${srmPurchaseUserId}`,
  );
